import { randomInt } from './func';

export function getUniversityWithFlattedUrl(uni: UniversityEntityOriginal) {
  const u = { ...uni };
  if (Array.isArray(u.universityURL)) {
    const index = randomInt(0, u.universityURL.length);
    u.universityURL = u.universityURL[index];
  }
  return u as UniversityEntity;
}

export function getUniversityAndOverrideUrl(uni: UniversityEntityOriginal, fixedURL: string) {
  const u = { ...uni };
  u.universityURL = fixedURL;
  return u as UniversityEntity;
}
